module.exports = __webpack_public_path__ + "img/unload-1-3.f30d43d7.png";